import { ReactComponent as AppleMusic } from '../assets/apple-music.svg';
import { ReactComponent as Spotify } from '../assets/spotify.svg';
import { ReactComponent as SoundCloud } from '../assets/soundcloud.svg';
// import { ReactComponent as YouTube } from '../assets/youtube.svg';
import { ReactComponent as YouTubeMusic } from '../assets/youtube-music.svg';
import { ReactComponent as Tidal } from '../assets/tidal.svg';
import { ReactComponent as BandCamp } from '../assets/bandcamp.svg';
import { ReactComponent as AmazonMusic } from '../assets/amazon-music.svg';
import work from '../data/work';

const AlbumLinks = ({ album, className }) => (
  <div className={className}>
    {album.links.bandcamp && (
      <a href={album.links.bandcamp} target="_blank" rel="noopener noreferrer" aria-label={`Purchase and download ${album.title} by ${album.artist} on Bandcamp`}>
        <BandCamp className='link-logo' />
      </a>
    )}
    {album.links.applemusic && (
      <a href={album.links.applemusic} target="_blank" rel="noopener noreferrer" aria-label={`Listen to ${album.title} by ${album.artist} on Apple Music`}>
        <AppleMusic className='link-logo' />
      </a>
    )}
    {album.links.tidal && (
      <a href={album.links.tidal} target="_blank" rel="noopener noreferrer" aria-label={`Listen to ${album.title} by ${album.artist} on TIDAL`}>
        <Tidal className='link-logo' />
      </a>
    )}
    {album.links.spotify && (
      <a href={album.links.spotify} target="_blank" rel="noopener noreferrer" aria-label={`Listen to ${album.title} by ${album.artist} on Spotify`}>
        <Spotify className='link-logo' />
      </a>
    )}
    {album.links.soundcloud && (
      <a href={album.links.soundcloud} target="_blank" rel="noopener noreferrer" aria-label={`Listen to ${album.title} by ${album.artist} on Soundcloud`}>
        <SoundCloud className='link-logo' />
      </a>
    )}
    {/* {album.links.youtube && (
      <a href={album.links.youtube} target="_blank" rel="noopener noreferrer" aria-label={`Listen to ${album.title} by ${album.artist} on YouTube`}>
        <YouTube className='link-logo' />
      </a>
    )} */}
    {album.links.youtubemusic && (
      <a href={album.links.youtubemusic} target="_blank" rel="noopener noreferrer" aria-label={`Listen to ${album.title} by ${album.artist} on YouTube Music`}>
        <YouTubeMusic className='link-logo' />
      </a>
    )}
    {album.links.amazonmusic && (
      <a href={album.links.amazonmusic} target="_blank" rel="noopener noreferrer" aria-label={`Listen to ${album.title} by ${album.artist} on Amazon Music`}>
        <AmazonMusic className='link-logo' />
      </a>
    )}
  </div>
);

function AlbumGrid() {
  // Seeded random function based on date
  const seededRandom = (seed) => {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  };

  // Get today's date as a number seed (YYYYMMDD format)
  const today = new Date();
  const dateSeed = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();

  // Sort by release date (newest first)
  const sortedWork = [...work]
    .filter(album => album.show)
    .sort((a, b) => {
      // Handle albums without release dates by putting them at the end
      if (!a.releaseDate) return 1;
      if (!b.releaseDate) return -1;
      return new Date(b.releaseDate) - new Date(a.releaseDate);
    });

  // Separate featured and non-featured work
  const featuredWork = sortedWork.filter(album => album.featured);
  const regularWork = sortedWork.filter(album => !album.featured);
  
  // Shuffle featured work with date-based seed
  const shuffledFeatured = [...featuredWork].sort((a, b) => {
    const hashA = a.title.length + a.artist.length;
    const hashB = b.title.length + b.artist.length;
    return seededRandom(dateSeed + hashA) - seededRandom(dateSeed + hashB);
  });
  
  // Interleave: regular, featured (shuffled), regular, featured (shuffled), etc.
  const orderedWork = [];
  const maxLength = Math.max(regularWork.length, shuffledFeatured.length);
  
  for (let i = 0; i < maxLength; i++) {
    if (i < regularWork.length) {
      orderedWork.push(regularWork[i]);
    }
    if (i < shuffledFeatured.length) {
      orderedWork.push(shuffledFeatured[i]);
    }
  }

  return (
    <div className="album-grid">
      {orderedWork.map((album, idx) => (
        <div key={idx} className="album-item">
          <img src={album.artwork} alt={album.title} className="album-artwork" />
          <div className="album-info">
            <div className="album-main">
              <div className='title'>
                {album.artist} - {album.title}
              </div>
              
            </div>
            <div className='role'>
                {album.role}
              </div>
            <AlbumLinks album={album} className="links" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default AlbumGrid;